export const closeOutFeature = {
  closeout: {
    id: 217,
    featureName: 'Close Out',
  },
} as const;
export const closeOutFeaturesList = Object.entries(closeOutFeature).map(([key, v]) => ({
  key,
  ...v,
  createdBy: 'System',
}));

export const closeOutModuleFeatures = [{ moduleId: 20, featureId: closeOutFeature['closeout'].id }];
